const textProps = {
  title: "Your account",
  subtitle:
    "That’s the main thing people are controlled by! Thoughts - their perception of themselves!",
  image: require("assets/img/pages/georgie.jpg").default,
  skewColor: "blueGray",
};
export default textProps;
